'use strict';

import moment from 'angular-moment';

export class CompareWeatherLogic {
  /*@ngInject*/
  constructor(moment) {
    this.moment = moment;
  }

  compareDateTime(weathers, samplingTimes) {
    return this.compare(weathers, samplingTimes, 'measured_at', 'YYYY-MM-DD HH:mm:ss');
  }

  compareHourly(weathers, samplingTimes) {
    return this.compare(weathers, samplingTimes, 'measured_at', 'HH:mm');
  }

  compareDaily(dailyWeathers, samplingTimes) {
    return this.compare(dailyWeathers, samplingTimes, 'date', 'YYYY-MM-DD');
  }

  compare(weathers, samplingTimes, propertyName, timeFormat) {
    let result = [];

    for(let time of samplingTimes) {
      let timeStr = time;
      if(typeof timeStr !== 'string') {
        timeStr = this.moment(time).format(timeFormat);
      }
      const matchedWeather = weathers.find(weather => {
        return this.moment(weather[propertyName]).format(timeFormat) === timeStr;
      });

      result.push(matchedWeather);
    }

    const isAllNotFound = result.every(weather => {
      return (!weather || !weather.name);
    });
    if(isAllNotFound) {
      result = [];
    }

    return result;
  }
}

export default angular.module('leptonApp.CompareWeatherLogic', [moment])
  .service('CompareWeatherLogic', ['moment', CompareWeatherLogic])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/compare_weather/compare_weather.logic.js